export default __webpack_public_path__ + "static/media/servicing.b5a59935.jpg";